module.exports = __webpack_public_path__ + "static/rabbit2-bc8966926ece2598e7ec1a5544d066d9.webp";